import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, articles, faqItems, testimonials } from '@/mocks/siteData';

const articleImageMap: Record<string, string> = {
  'article-android-download': 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20mobile%20game%20download%20screen%20with%20Android%20interface%2C%20clean%20minimal%20background%2C%20warm%20amber%20lighting%2C%20professional%20product%20photography%2C%20soft%20shadows%2C%20gaming%20aesthetic&width=640&height=360&seq=article-android-download&orientation=landscape',
  'article-ios-download': 'https://readdy.ai/api/search-image?query=iPhone%20displaying%20App%20Store%20game%20download%20page%20with%20warm%20lighting%2C%20clean%20minimal%20white%20background%2C%20professional%20product%20photography%2C%20soft%20golden%20accents%2C%20elegant%20composition&width=640&height=360&seq=article-ios-download&orientation=landscape',
  'article-install-errors': 'https://readdy.ai/api/search-image?query=Smartphone%20error%20notification%20screen%20with%20warm%20ambient%20lighting%2C%20clean%20minimal%20background%2C%20tech%20support%20aesthetic%2C%20soft%20golden%20highlights%2C%20professional%20product%20photography&width=640&height=360&seq=article-install-errors&orientation=landscape',
  'article-beginner-gifts': 'https://readdy.ai/api/search-image?query=Mobile%20game%20reward%20screen%20showing%20gift%20boxes%20and%20bonuses%20with%20warm%20golden%20lighting%2C%20clean%20minimal%20background%2C%20festive%20gaming%20atmosphere%2C%20professional%20product%20photography&width=640&height=360&seq=article-beginner-gifts&orientation=landscape',
  'article-character-build': 'https://readdy.ai/api/search-image?query=Fantasy%20game%20character%20upgrade%20interface%20on%20mobile%20screen%20with%20warm%20lighting%2C%20clean%20background%2C%20epic%20gaming%20aesthetic%2C%20professional%20product%20photography%2C%20soft%20golden%20glow&width=640&height=360&seq=article-character-build&orientation=landscape',
  'article-account-security': 'https://readdy.ai/api/search-image?query=Mobile%20phone%20security%20shield%20icon%20with%20warm%20protective%20glow%2C%20clean%20minimal%20background%2C%20trustworthy%20atmosphere%2C%20professional%20product%20photography%2C%20soft%20amber%20lighting&width=640&height=360&seq=article-account-security&orientation=landscape',
  'article-version-update': 'https://readdy.ai/api/search-image?query=Mobile%20game%20update%20notification%20screen%20showing%20new%20features%20with%20warm%20lighting%2C%20clean%20minimal%20background%2C%20exciting%20gaming%20atmosphere%2C%20professional%20product%20photography&width=640&height=360&seq=article-version-update&orientation=landscape',
  'article-network-fix': 'https://readdy.ai/api/search-image?query=Smartphone%20network%20optimization%20concept%20with%20signal%20bars%20and%20warm%20glow%2C%20clean%20minimal%20background%2C%20tech%20support%20aesthetic%2C%20professional%20product%20photography%2C%20soft%20amber%20lighting&width=640&height=360&seq=article-network-fix&orientation=landscape',
  'article-recharge': 'https://readdy.ai/api/search-image?query=Mobile%20game%20shop%20interface%20showing%20premium%20currency%20and%20special%20offers%20with%20warm%20golden%20lighting%2C%20clean%20minimal%20background%2C%20luxurious%20gaming%20atmosphere%2C%20professional%20product%20photography&width=640&height=360&seq=article-recharge&orientation=landscape',
};

function FAQItem({ question, answer, isOpen, onToggle }: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border border-background-200/70 rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-background-100/50 transition-colors"
      >
        <span className="font-medium text-foreground-900 pr-4">{question}</span>
        <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
}

export default function Home() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const [expandedTestimonials, setExpandedTestimonials] = useState(false);
  const displayedTestimonials = expandedTestimonials ? testimonials : testimonials.slice(0, 4);

  const handleFaqToggle = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const featuredArticles = articles.slice(0, 6);

  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'PG征途国际下载安装',
    url: 'https://pgzhengtu.com',
    description: 'PG征途国际下载安装全流程指南，提供官方正版客户端安卓iOS最新版本，安全无病毒，一键下载安装即玩。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://pgzhengtu.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'PG征途国际',
    url: 'https://pgzhengtu.com',
    description: 'PG征途国际官方正版下载安装指南平台',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://pgzhengtu.com/' },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Epic%20fantasy%20game%20landscape%20with%20golden%20warm%20lighting%2C%20ancient%20Chinese%20architecture%20silhouettes%2C%20dramatic%20clouds%2C%20majestic%20mountain%20peaks%20in%20background%2C%20atmospheric%20mist%2C%20rich%20amber%20and%20crimson%20color%20palette%2C%20cinematic%20composition%2C%20game%20art%20style%2C%20epic%20scale%2C%20no%20text%2C%20immersive%20fantasy%20world&width=1800&height=800&seq=hero-bg-01&orientation=landscape"
            alt="PG征途国际游戏背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-medium mb-6">
                <i className="ri-shield-check-line"></i>
                <span>官方正版认证 · 安全无毒 · 海量玩家好评</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
                PG征途国际下载安装
                <br />
                <span className="text-primary-300">官方正版客户端一键安装指南</span>
              </h1>

              <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
                PG征途国际官方正版客户端安卓iOS最新版本下载，安全无病毒，一键安装即玩。
                支持新手礼包领取，海量玩家好评，立即下载体验PG征途国际精彩游戏内容。
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="#download"
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-base font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-android-line text-lg"></i>
                  安卓版下载
                </a>
                <a
                  href="#download"
                  className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/30 text-white rounded-lg text-base font-semibold whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS版下载
                </a>
                <Link
                  to="/category/xiazai-jiaocheng"
                  className="w-full sm:w-auto px-8 py-3.5 text-white/80 hover:text-white rounded-lg text-sm font-medium whitespace-nowrap transition-colors flex items-center justify-center gap-2"
                >
                  查看下载教程
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="flex items-center justify-center gap-6 mt-8 text-white/60 text-sm">
                <div className="flex items-center gap-1.5">
                  <i className="ri-star-fill text-accent-400 text-sm"></i>
                  <span>4.9分好评</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-user-line text-sm"></i>
                  <span>500万+玩家</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-sm"></i>
                  <span>官方正版认证</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Grid Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                下载安装全攻略
              </h2>
              <p className="text-foreground-600 max-w-2xl mx-auto">
                从下载到上手，一站式PG征途国际指南服务，覆盖安卓、iOS全平台
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-200"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-200">
                      <i className={`${cat.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-200`}></i>
                    </div>
                    <div className="min-w-0">
                      <h3 className="font-heading font-semibold text-foreground-900 mb-1 text-sm">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                        {cat.description}
                      </p>
                    </div>
                    <div className="flex-shrink-0 self-center ml-auto">
                      <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  精选教程与攻略
                </h2>
                <p className="text-foreground-600 text-sm">
                  最新最全的PG征途国际下载安装教程与游戏攻略
                </p>
              </div>
              <Link
                to="/category/xiazai-jiaocheng"
                className="px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200"
                >
                  <div className="aspect-[16/9] overflow-hidden bg-background-200">
                    <img
                      src={articleImageMap[article.imageSeq] || articleImageMap['article-android-download']}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <div className="flex items-center gap-2 mb-2">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs font-medium"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 text-sm leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span>{article.date}</span>
                      <span>{article.readTime}阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                常见问题解答
              </h2>
              <p className="text-foreground-600 text-sm">
                关于PG征途国际下载安装的常见疑问，这里都有答案
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => (
                <FAQItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  isOpen={openFaqIndex === index}
                  onToggle={() => handleFaqToggle(index)}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                玩家真实评价
              </h2>
              <p className="text-foreground-600 text-sm">
                来自PG征途国际真实玩家的下载安装体验分享
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {displayedTestimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-50 rounded-xl border border-background-200/70 p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, si) => (
                      <i key={si} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-4">
                    &ldquo;{t.comment}&rdquo;
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span className="font-medium text-foreground-600">{t.name}</span>
                    <span>{t.date}</span>
                  </div>
                </div>
              ))}
            </div>

            {testimonials.length > 4 && (
              <div className="text-center mt-6">
                <button
                  onClick={() => setExpandedTestimonials(!expandedTestimonials)}
                  className="px-5 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1 mx-auto cursor-pointer"
                >
                  {expandedTestimonials ? '收起评价' : '查看更多评价'}
                  {expandedTestimonials ? (
                    <i className="ri-arrow-up-s-line"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line"></i>
                  )}
                </button>
              </div>
            )}
          </div>
        </section>

        {/* Download CTA Section */}
        <section id="download" className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20flowing%20golden%20and%20amber%20light%20streams%2C%20soft%20bokeh%20effects%2C%20luxurious%20gaming%20atmosphere%2C%20dark%20elegant%20base%20with%20warm%20highlight%20accents%2C%20cinematic%20lighting%2C%20premium%20quality%20texture&width=1800&height=600&seq=cta-bg-01&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/90"></div>

          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
              准备好体验PG征途国际了吗？
            </h2>
            <p className="text-base text-white/70 mb-8 max-w-2xl mx-auto">
              选择您的设备平台，一键下载官方正版客户端，安全安装，即刻开启精彩游戏之旅。新手还可领取专属礼包哦！
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#"
                className="w-full sm:w-auto px-10 py-4 bg-primary-500 hover:bg-primary-600 text-white rounded-xl text-base font-bold whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center justify-center gap-3"
              >
                <i className="ri-android-line text-xl"></i>
                安卓版下载
                <span className="text-xs font-normal opacity-75">v3.8.2</span>
              </a>
              <a
                href="#"
                className="w-full sm:w-auto px-10 py-4 bg-white hover:bg-white/90 text-foreground-900 rounded-xl text-base font-bold whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center justify-center gap-3"
              >
                <i className="ri-apple-line text-xl"></i>
                iOS版下载
                <span className="text-xs font-normal opacity-50">v3.8.2</span>
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-white/50 text-xs">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line"></i> 安全无毒认证
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-download-cloud-2-line"></i> 500万+次下载
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-star-fill text-accent-400"></i> 4.9分用户评分
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-device-line"></i> 安卓/iOS全支持
              </span>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}